export default {
  getProducts: state => state.products,
  getStateSlider: state => state.enableSlider,
  getScrollbar: state => state.scrollbar,
  getCurrentData: (state, g) => Object.assign({}, state[state.route.name], g.getCurrentVoice),
  techFeaturesPages: state => state.global.header.filter(voice => voice.inSlider),
  getCurrentVoice: (s, g) => g.techFeaturesPages.find(v => v.id === s.route.name),
  currentInSlider: s => s.global.header.find(v => v.id === s.route.name).inSlider,
  checkInSlider: s => params => s.global.header.find(v => v.id === params).inSlider,
  currentHand: s => params => s.global.header.find(v => v.id === params).handNumber,
  getIsMenuInTransition: state => state.isMenuInTransition,

  getDeedProduct: state => state.products.find(v => v.handle === 'get'),

  getNextPage: (state, getters) => {
    const current = getters.getCurrentVoice
    const currentIndex = getters.techFeaturesPages.indexOf(current)
    const l = getters.techFeaturesPages.length - 1

    return (currentIndex < l)
      ? getters.techFeaturesPages[currentIndex + 1] : getters.techFeaturesPages[0]
  },
  getPrevPage: (state, getters) => {
    const current = getters.getCurrentVoice
    const currentIndex = getters.techFeaturesPages.indexOf(current)
    const l = getters.techFeaturesPages.length - 1

    return (currentIndex <= 0)
      ? getters.techFeaturesPages[l] : getters.techFeaturesPages[currentIndex - 1]
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js